/* ============================================================================
   DAILE custom side cart — TASK 10 (база) + TASK 11 (апсейл) + TASK 11b (fix рендера).
   Глобальный (грузится из cart-drawer.liquid).

   РЕНДЕР: из /cart.js (JSON) + встроенного каталога апсейлов ([data-daile-cart-upsells]).
   Section Rendering API НЕ отдаёт секцию из section-group (overlay-group) → дровер
   рендерим целиком в JS (как TASK 10), но с апсейл-секциями под каждой картиной.

   Апсейл = отдельный line item того же product_id со свойством `Set: <title картины>`.
   Удаление картины авто-удаляет её апсейлы (batch /cart/update.js).
   ============================================================================ */
(function () {
  'use strict';

  /* DAILE custom (i18n): корень магазина с учётом языка — на арабской витрине это «/ar/».
     Без него ссылки уводили покупателя обратно на английскую версию. */
  var SHOP_ROOT_LOC = (function () {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  })();


  /* DAILE custom (i18n): строки приходят из snippets/daile-t.liquid через
     window.DAILE_CART_T (см. sections/cart-drawer.liquid). 2-й аргумент — EN-фоллбек. */
  var CT = (typeof window !== 'undefined' && window.DAILE_CART_T) || {};
  function ct(key, def) { return CT[key] || def; }


  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var cart = document.getElementById('daile-cart');
    if (!cart) return;
    var panel = cart.querySelector('.daile-cart__panel');
    var itemsEl = cart.querySelector('[data-daile-cart-items]');
    var subtotalEl = cart.querySelector('[data-cart-subtotal]');
    var savingsEl = cart.querySelector('[data-cart-savings]'); // QA29
    var savingsValEl = cart.querySelector('[data-cart-savings-value]'); // QA29
    var titleCountEl = cart.querySelector('[data-cart-title-count]'); // QA31
    var lastFocused = null;
    var busy = false;

    // каталог апсейлов (id, variantId, title, description, price, image)
    var catalog = [];
    try {
      var catEl = cart.querySelector('[data-daile-cart-upsells]');
      if (catEl && catEl.textContent.trim()) catalog = JSON.parse(catEl.textContent) || [];
    } catch (e) { console.error('[daile-cart] upsell catalog parse', e); }
    var upsellIds = catalog.map(function (u) { return u.id; });

    /* ---------- helpers ---------- */
    // TASK28: мультивалюта. Символ/формат — по валюте ПОКУПАТЕЛЯ (presentment) через Intl.NumberFormat
    // (тот же подход, что нативный Prestige theme.js). currencyCode из /cart.js (cart.currency).
    // Без копеек (minimumFractionDigits:0) — премиум-вид (120, не 120.00). Символ валюты НЕ хардкодим.
    function money(cents, currencyCode) {
      var code = currencyCode || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      var amount = (cents || 0) / 100;
      try {
        return new Intl.NumberFormat((window.Shopify && Shopify.locale) || undefined, {
          style: 'currency', currency: code,
          minimumFractionDigits: 0, maximumFractionDigits: 0
        }).format(amount);
      } catch (e) {
        return code + ' ' + Math.floor(amount); // fallback при неизвестном коде валюты
      }
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    // TASK30: уникальный line id (общий для handleAdd и addOneMore) → Shopify не схлопывает одинаковые товары
    function uid() { return Date.now() + '-' + Math.random().toString(36).slice(2); }

    /* ---------- open / close ---------- */
    function openCart() {
      if (cart.classList.contains('is-open')) return;
      lastFocused = document.activeElement;
      cart.classList.add('is-open');
      cart.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var closeBtn = cart.querySelector('.daile-cart__close');
      if (closeBtn) { try { closeBtn.focus(); } catch (e) {} }
    }
    function closeCart() {
      if (!cart.classList.contains('is-open')) return;
      cart.classList.remove('is-open');
      cart.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocused && lastFocused.focus) { try { lastFocused.focus(); } catch (e) {} }
    }

    /* ---------- render (из /cart.js + каталог) ---------- */
    function renderUpsell(up, parentLineId, parentTitle, allItems, currency) {
      var attached = null;
      for (var i = 0; i < allItems.length; i++) {
        var it = allItems[i];
        // TASK30-B: связь апсейл↔картина по _parent_line (НЕ по Set/title — одинаковые картины теперь разные строки)
        if (it.product_id === up.id && it.properties && it.properties._parent_line === parentLineId) { attached = it; break; }
      }
      var action = attached
        ? '<div class="daile-cart__upsell-added"><span class="daile-cart__upsell-added-label">' + ct('js_upsell_added', '✓ Added') + '</span>' +
            '<button type="button" class="daile-cart__upsell-remove" data-upsell-action="remove" data-line-item-key="' + esc(attached.key) + '" aria-label="' + ct('js_upsell_remove', 'Remove') + ' ' + esc(up.title) + '"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6 18 18M18 6 6 18"/></svg></button></div>'
        : '<button type="button" class="daile-cart__upsell-btn" data-upsell-action="add" data-variant-id="' + up.variantId + '" data-parent-line="' + esc(parentLineId) + '" data-set-name="' + esc(parentTitle) + '">' + ct('js_upsell_add', 'Add') + '</button>';
      return '<article class="daile-cart__upsell" data-upsell-product-id="' + up.id + '">' +
          (up.image ? '<img src="' + esc(up.image) + '" alt="" loading="lazy">' : '<span></span>') +
          '<div class="daile-cart__upsell-info"><h4>' + esc(up.title) + '</h4>' +
            '<p>' + esc(up.description) + '</p>' +
            '<span class="daile-cart__upsell-price">' + money(up.price, currency) + '</span></div>' +
          action +
        '</article>';
    }

    // QA36: свёрнутость оффер-блока — sessionStorage по parentLineId (renderCart пересобирает
    // innerHTML при каждом refreshCart → состояние в DOM не живёт). Дефолт — развёрнуто.
    function isUpsellsCollapsed(parentLineId) {
      try { return sessionStorage.getItem('daile_upsells_collapsed_' + parentLineId) === '1'; } catch (e) { return false; }
    }
    function setUpsellsCollapsed(parentLineId, collapsed) {
      try {
        if (collapsed) sessionStorage.setItem('daile_upsells_collapsed_' + parentLineId, '1');
        else sessionStorage.removeItem('daile_upsells_collapsed_' + parentLineId);
      } catch (e) { /* private mode — тогл живёт до ближайшего re-render */ }
    }

    /* QA-волна1-доработка: зачёркнутые цены («скидка 15%» у DAILE = compare at
       price товара, для Shopify-корзины это НЕ скидка — total_discount=0 и
       /cart.js поле compare_at_price не отдаёт). Тянем /products/<handle>.js
       (цены в центах, в валюте покупателя) и кэшируем variant_id → compare_at. */
    var comparePrices = {};     // variant_id → compare_at_price (центы; 0 = нет зачёркнутой)
    var compareFetched = {};    // handle → true (запрошен — повторно не дёргаем, даже после 404)
    function loadComparePrices(data) {
      var pending = [];
      for (var i = 0; i < data.items.length; i++) {
        var it = data.items[i];
        if (comparePrices[it.variant_id] !== undefined || compareFetched[it.handle]) continue;
        compareFetched[it.handle] = true;
        pending.push(
          fetch(ROOT + 'products/' + it.handle + '.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (p) {
              if (p && p.variants) {
                for (var v = 0; v < p.variants.length; v++) {
                  comparePrices[p.variants[v].id] = p.variants[v].compare_at_price || 0;
                }
              }
            })
            .catch(function () { /* нет данных — просто без зачёркнутой цены */ })
        );
      }
      return pending;
    }
    // «Полная» цена строки: compare_at×qty, если он выше фактической; иначе фактическая
    function compareLinePrice(it) {
      var cap = comparePrices[it.variant_id] || 0;
      return cap > it.final_price ? cap * it.quantity : it.final_line_price;
    }

    function renderItem(item, allItems, currency) {
      var props = item.properties || {};
      var isCz = !!props._design; // TASK55: строка кастомайзера (персонализированный пазл)
      var parentLineId = props._line_id || item.key; // TASK30-B: связь по _line_id (fallback key)
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="daile-cart__item-variant">' + esc(item.variant_title) + '</p>' : '';
      // Миниатюра = превью дизайна клиента. TASK61: приоритет —
      // CDN-превью из _design (постоянное, кросс-сессия); fallback —
      // sessionStorage-thumb (мгновенный, та же сессия); иначе фото товара.
      var imgSrc = item.image;
      var czOrient = 'v'; // TASK78 п.9: ориентация дизайна для миниатюры
      if (isCz) {
        try {
          var d = JSON.parse(props._design);
          if (d && d.photo && d.photo.previewUrl) imgSrc = d.photo.previewUrl;
          if (d && d.orientation) czOrient = d.orientation; // TASK78 п.9
        } catch (e) { /* битый _design — идём к fallback */ }
      }
      if (props._line_id) {
        try {
          var czPrev = sessionStorage.getItem('daile_cz_preview_' + props._line_id);
          if (czPrev) imgSrc = czPrev; // локальный thumb перекрывает CDN, пока та же сессия (мгновенно)
        } catch (e) { /* private mode — остаётся CDN-превью или фото товара */ }
      }
      var img = imgSrc
        ? '<img class="daile-cart__item-image' + (isCz && czOrient === 'h' ? ' is-landscape' : '') + '" src="' + esc(imgSrc) + '" alt="' + esc(item.product_title) + '" loading="lazy" width="80" height="100">'
        : '<span class="daile-cart__item-image"></span>';
      // TASK83: дочерние строки кастомайзера — ВСЕ (включая сумку из каталога
      // дровера): выбранное отображается строками «в списке к остальным апсейлам»
      // (модель Никиты), а его оффер-блок скрывается ниже.
      var attachedItems = [];
      if (isCz) {
        for (var ci = 0; ci < allItems.length; ci++) {
          var c = allItems[ci];
          if (c.properties && c.properties._parent_line === parentLineId) {
            attachedItems.push(c);
          }
        }
      }
      // TASK55: цена строки = пазл + его опции (иначе «сверху €100, внизу €206»)
      var lineTotal = item.final_line_price;
      for (var ti = 0; ti < attachedItems.length; ti++) lineTotal += attachedItems[ti].final_line_price;
      // QA-волна1-доработка: зачёркнутая полная цена (compare at), как на PDP
      var compareTotal = compareLinePrice(item);
      for (var ci2 = 0; ci2 < attachedItems.length; ci2++) compareTotal += compareLinePrice(attachedItems[ci2]);
      var priceHtml = (compareTotal > lineTotal ? '<s class="daile-cart__item-compare">' + money(compareTotal, currency) + '</s> ' : '') +
        money(lineTotal, currency);
      // TASK55: «Add one more» для кастома скрыт — дубль ушёл бы БЕЗ персонализации.
      // TASK56: вместо него — сдержанная ссылка Edit (возврат в кастомайзер,
      // ?edit=<_line_id>: дизайн из _design, фото из IndexedDB)
      var addMore = isCz
        ? '<a class="daile-cart__item-edit" href="' + SHOP_ROOT_LOC + 'pages/customizer?edit=' + encodeURIComponent(parentLineId) + '">' + ct('js_cart_edit_design', 'Edit design') + '</a>'
        : '<button type="button" class="daile-cart__add-more" data-add-more data-variant-id="' + item.variant_id + '">' + ct('js_cart_add_one', 'Add one more') + '</button>';
      // TASK30-C: qty-контрол убран (каждое добавление = отдельная строка, qty всегда 1); цена остаётся
      var main = '<div class="daile-cart__item-main">' + img +
        '<div class="daile-cart__item-info"><h3 class="daile-cart__item-title">' + esc(item.product_title) + '</h3>' + variant +
          '<div class="daile-cart__item-bottom">' + addMore +
            '<span class="daile-cart__item-price">' + priceHtml + '</span></div></div>' +
        '<button type="button" class="daile-cart__item-remove" data-line-item-remove aria-label="Remove item">' +
          '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg></button>' +
        '</div>';
      var attachedHtml = '';
      if (attachedItems.length) {
        attachedHtml = '<ul class="daile-cart__attached">' + attachedItems.map(function (c) {
          return '<li class="daile-cart__attached-row"><span class="daile-cart__attached-title">' + esc(c.product_title) + '</span>' +
            '<span class="daile-cart__attached-price">+' + money(c.final_line_price, currency) + '</span>' +
            '<button type="button" class="daile-cart__upsell-remove" data-upsell-action="remove" data-line-item-key="' + esc(c.key) + '" aria-label="' + ct('js_upsell_remove', 'Remove') + ' ' + esc(c.product_title) + '"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6 18 18M18 6 6 18"/></svg></button></li>';
        }).join('') + '</ul>';
      }
      var upsells = '';
      if (catalog.length && upsellIds.indexOf(item.product_id) === -1) {
        var offers = catalog;
        // TASK83 (фикс регрессии TASK78 п.10): для кастом-строки скрываем офферы
        // товаров, УЖЕ присоединённых к этому пазлу (сравнение по product id —
        // не зависит от переименований). Выбрал сумку → она строкой в списке
        // выше, блок-оффер исчезает; не выбрал → блок предлагается как обычно.
        if (isCz) {
          offers = catalog.filter(function (up) {
            for (var oi = 0; oi < allItems.length; oi++) {
              var it2 = allItems[oi];
              if (it2.product_id === up.id && it2.properties && it2.properties._parent_line === parentLineId) return false;
            }
            return true;
          });
        }
        if (offers.length) {
          var collapsed = isUpsellsCollapsed(parentLineId); // QA36
          upsells = '<div class="daile-cart__upsells' + (collapsed ? ' is-collapsed' : '') + '" data-upsells-for="' + esc(item.key) + '" data-product-title="' + esc(item.product_title) + '">' +
            '<button type="button" class="daile-cart__upsells-title" data-upsells-toggle data-parent-line="' + esc(parentLineId) + '" aria-expanded="' + (collapsed ? 'false' : 'true') + '">' + ct('js_upsell_title', 'Complete this art set') +
              '<svg class="daile-cart__upsells-chevron" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg></button>' +
            offers.map(function (up) { return renderUpsell(up, parentLineId, item.product_title, allItems, currency); }).join('') +
            '</div>';
        }
      }
      return '<li class="daile-cart__item" data-line-item-key="' + esc(item.key) + '">' + main + attachedHtml + upsells + '</li>';
    }

    /* ---------- free shipping bar (TASK26) ---------- */
    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function playConfetti(host) {
      if (prefersReducedMotion()) return;
      var colors = ['#161514', '#f2f2f0', '#c9a86a']; // чёрный / бежевый / тёплый акцент — НЕ радужное
      var wrap = document.createElement('div');
      wrap.className = 'daile-cart__confetti';
      for (var i = 0; i < 18; i++) {
        var p = document.createElement('i');
        var dist = 34 + Math.random() * 46;
        var tx = (Math.random() < 0.5 ? -1 : 1) * Math.random() * dist;
        var ty = -(18 + Math.random() * 48); // разлёт вверх от бара
        var rot = Math.random() * 540 - 270;
        p.style.cssText =
          'left:' + (15 + Math.random() * 70).toFixed(1) + '%;' +
          'background:' + colors[i % colors.length] + ';' +
          '--tx:' + tx.toFixed(1) + 'px;--ty:' + ty.toFixed(1) + 'px;--rot:' + rot.toFixed(0) + 'deg;' +
          'animation-delay:' + (Math.random() * 0.12).toFixed(2) + 's;';
        wrap.appendChild(p);
      }
      host.appendChild(wrap);
      window.setTimeout(function () { if (wrap.parentNode) wrap.parentNode.removeChild(wrap); }, 1700);
    }

    // TASK28 мультивалюта: total_price из /cart.js — presentment-центы (валюта покупателя); порог
    // (data-threshold, EUR-центы) приводим к presentment по Shopify.currency.rate — см. ниже.
    // Разница для состояния B форматируется в валюте покупателя через money(cents, currency).
    function updateShippingBar(data) {
      var bar = cart.querySelector('[data-shipping-bar]');
      if (!bar) return;
      var count = data.item_count || 0;
      if (count === 0) { // пустая корзина → сбрасываем флаг (анимация сыграет снова после нового добавления)
        try { sessionStorage.removeItem('daile_shipping_anim_shown'); } catch (e) {}
        return;
      }
      var fill = bar.querySelector('[data-shipping-fill]');
      var plane = bar.querySelector('[data-shipping-plane]');
      var textEl = bar.querySelector('[data-shipping-text]');
      var thresholdBase = parseInt(bar.getAttribute('data-threshold'), 10) || 0; // порог в БАЗОВОЙ валюте (EUR-центы)
      if (thresholdBase <= 0 || !fill || !textEl) return;
      // TASK28: total_price из /cart.js — в presentment (валюте покупателя). Приводим ПОРОГ к той же
      // валюте по Shopify.currency.rate, иначе сравнение EUR-центы vs presentment-центы было бы сломано.
      // EUR-покупатель: rate=1 → как раньше. NB: для price-list-валют rate приблизителен (флаг в отчёте).
      var currency = data.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1;
      var threshold = Math.round(thresholdBase * rate); // порог в presentment-центах
      var total = data.total_price || 0;                // presentment-центы
      var reached = total >= threshold;
      var pct = threshold > 0 ? Math.min(100, Math.round(total / threshold * 100)) : 100;

      if (reached) textEl.innerHTML = '<svg class="daile-cart__shipping-check" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>' + ct('js_ship_unlocked', 'Free shipping unlocked!');
      else textEl.textContent = ct('js_ship_add', 'Add ') + money(threshold - total, currency) + ct('js_ship_for_free', ' for free shipping');

      // самолёт и заливка двигаются ОДНИМ таймингом (CSS transition 1.8s у обоих) → самолёт всегда на кончике fill
      function setPos(p, animated) {
        var t = animated ? '' : 'none';
        fill.style.transition = t;
        fill.style.width = p + '%';
        if (plane) { plane.style.transition = t; plane.style.left = p + '%'; }
      }

      var animShown;
      try { animShown = sessionStorage.getItem('daile_shipping_anim_shown'); } catch (e) { animShown = '1'; }
      if (!animShown) {
        // первое появление непустой корзины в сессии → анимируем
        try { sessionStorage.setItem('daile_shipping_anim_shown', '1'); } catch (e) {}
        setPos(0, false);          // 1) сброс в 0 мгновенно
        void fill.offsetWidth;     //    reflow
        window.setTimeout(function () {   // 2) задержка 600мс — drawer успевает выехать, виден старт с нуля
          setPos(pct, true);              // 3) заливка 1.8s (CSS) + самолёт синхронно
          textEl.classList.remove('is-shimmer');
          void textEl.offsetWidth;        //    рестарт анимации
          textEl.classList.add('is-shimmer');   // 4) shimmer ОДИН проход во время заливки
          window.setTimeout(function () { textEl.classList.remove('is-shimmer'); }, 1850);
          if (reached) window.setTimeout(function () { playConfetti(bar); }, 1800); // 5) конфетти ПОСЛЕ заливки
        }, 600);
      } else {
        setPos(pct, false); // статично, без анимации — самолёт сразу на месте (справа при A)
      }
    }

    // QA-волна1-доработка: items+Savings отдельной функцией — их можно дорисовать
    // после подгрузки compare-цен, не переигрывая анимацию шипинг-бара/бэджа
    function renderItemsAndSavings(data, currency) {
      var count = data.item_count || 0;
      if (count > 0 && itemsEl) {
        // TASK30-B: картина = НЕ апсейл (нет _parent_line И не апсейл-товар из каталога)
        var mains = data.items.filter(function (it) {
          var p = it.properties || {};
          return !p._parent_line && upsellIds.indexOf(it.product_id) === -1;
        });
        // TASK30-D: порядок добавления (первый сверху, дубли ниже) — сорт по _line_id (timestamp в начале uid)
        mains.sort(function (a, b) {
          var la = (a.properties && a.properties._line_id) || '';
          var lb = (b.properties && b.properties._line_id) || '';
          return la < lb ? -1 : (la > lb ? 1 : 0);
        });
        itemsEl.innerHTML = mains.map(function (it) { return renderItem(it, data.items, currency); }).join('');
      } else if (itemsEl) {
        itemsEl.innerHTML = '';
      }
      // QA29 + доработка: Savings = скидки Shopify (total_discount) ПЛЮС экономия
      // от зачёркнутых цен (compare at price — Shopify скидкой её не считает)
      var savingsTotal = data.total_discount || 0;
      for (var di = 0; di < data.items.length; di++) {
        var dit = data.items[di];
        var cap = comparePrices[dit.variant_id] || 0;
        if (cap > dit.final_price) savingsTotal += (cap - dit.final_price) * dit.quantity;
      }
      // Subtotal с зачёркнутым полным итогом рядом — как на PDP
      if (subtotalEl) {
        subtotalEl.innerHTML = (savingsTotal > 0
          ? '<s class="daile-cart__subtotal-compare">' + money(data.total_price + savingsTotal, currency) + '</s> '
          : '') + money(data.total_price, currency);
      }
      if (savingsEl) {
        if (savingsValEl) savingsValEl.textContent = money(savingsTotal, currency);
        savingsEl.hidden = savingsTotal === 0;
      }
    }

    function renderCart(data) {
      var count = data.item_count || 0;
      var currency = data.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'; // presentment код из /cart.js
      cart.classList.toggle('is-empty', count === 0);
      renderItemsAndSavings(data, currency);
      updateShippingBar(data);
      updateBadge(count);
      // QA-волна1-доработка: первая встреча с товаром — тянем его compare_at
      // и дорисовываем зачёркнутые цены/Savings; дальше кэш работает синхронно
      var pending = loadComparePrices(data);
      if (pending.length) {
        Promise.all(pending).then(function () { renderItemsAndSavings(data, currency); });
      }
    }

    function updateBadge(count) {
      document.querySelectorAll('cart-count').forEach(function (el) { el.textContent = count; });
      document.querySelectorAll('cart-dot').forEach(function (el) { el.classList.toggle('is-visible', count > 0); });
      // QA31: счётчик в заголовке дровера — «Your Cart (N)»; при 0 скобки не показываем
      if (titleCountEl) titleCountEl.textContent = count > 0 ? ' (' + count + ')' : '';
    }

    function refreshCart() {
      return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) { renderCart(data); return data; })
        .catch(function (e) { console.error('[daile-cart] refresh', e); });
    }

    /* ---------- мутации ---------- */
    function postJSON(endpoint, body) {
      return fetch(ROOT + endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
    }

    function changeLine(key, quantity) {
      if (busy) return;
      busy = true;
      postJSON('cart/change.js', { id: key, quantity: quantity })
        .then(function () { return refreshCart(); })
        .catch(function (e) { console.error('[daile-cart] change', e); })
        .then(function () { busy = false; });
    }

    // удаление картины + авто-удаление её апсейлов одним batch /cart/update.js
    function removeWithAttached(mainKey) {
      if (busy) return;
      busy = true;
      fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var main = null;
          c.items.forEach(function (it) { if (it.key === mainKey) main = it; });
          var updates = {};
          updates[mainKey] = 0;
          // TASK30-B: авто-удаление апсейлов ЭТОЙ картины — по _parent_line === её _line_id (fallback key), НЕ по Set===title
          if (main && !(main.properties && main.properties._parent_line)) {
            var parentId = (main.properties && main.properties._line_id) || main.key;
            c.items.forEach(function (it) {
              if (it.properties && it.properties._parent_line === parentId) updates[it.key] = 0;
            });
          }
          return postJSON('cart/update.js', { updates: updates });
        })
        .then(function () { return refreshCart(); })
        .catch(function (e) { console.error('[daile-cart] removeWithAttached', e); })
        .then(function () { busy = false; });
    }

    function handleAdd(form) {
      if (busy) return;
      busy = true;
      // TASK30-A: уникальный _line_id на каждое добавление → Shopify НЕ схлопывает одинаковые картины в qty=2.
      // Подчёркивание = скрытое свойство (на чекауте не видно). Покрывает PDP (нативная форма идёт сюда же).
      var fd = new FormData(form);
      fd.append('properties[_line_id]', uid());
      fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
        .then(function () { return refreshCart(); })
        .then(function () { openCart(); })
        .catch(function (err) { console.error('[daile-cart] add', err); if (err && err.description) window.alert(err.description); })
        .then(function () { busy = false; });
    }

    function addUpsell(variantId, parentLineId, title, btn) {
      if (busy) return;
      busy = true;
      if (btn) { btn.disabled = true; btn.textContent = ct('js_cart_adding', 'Adding…'); } // анти-double-click (race #1)
      // TASK30-B: _parent_line (скрытое) — точная связь с конкретной строкой картины; Set (видимое) — читаемость на чекауте/фулфилменте
      postJSON('cart/add.js', { id: variantId, quantity: 1, properties: { _parent_line: parentLineId, Set: title } })
        .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
        .then(function () { return refreshCart(); }) // re-render заменит кнопку на [✓ Added ×]
        .catch(function (err) {
          console.error('[daile-cart] upsell add', err);
          if (btn) { btn.disabled = false; btn.textContent = ct('js_cart_add', 'Add'); }
          if (err && err.description) window.alert(err.description);
        })
        .then(function () { busy = false; });
    }

    // TASK30 Фаза2: «Add one more» — тот же товар НОВОЙ строкой (новый _line_id) → встанет ниже (сорт mains по _line_id)
    function addOneMore(variantId, btn) {
      if (busy) return;
      busy = true;
      if (btn) { btn.disabled = true; btn.textContent = ct('js_cart_adding', 'Adding…'); } // антидабл-клик
      postJSON('cart/add.js', { id: variantId, quantity: 1, properties: { _line_id: uid() } })
        .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
        .then(function () { return refreshCart(); })
        .catch(function (err) {
          console.error('[daile-cart] add one more', err);
          if (btn) { btn.disabled = false; btn.textContent = ct('js_cart_add_one', 'Add one more'); }
          if (err && err.description) window.alert(err.description);
        })
        .then(function () { busy = false; });
    }

    /* TASK22 п.3: promo-логика (applyPromo + /discount/ валидация) удалена — поле промокода убрано. */

    /* ---------- wiring (делегирование на стабильном #daile-cart) ---------- */
    cart.addEventListener('click', function (e) {
      var upTgl = e.target.closest('[data-upsells-toggle]'); // QA36: свернуть/развернуть оффер-блок
      if (upTgl) {
        var upBox = upTgl.closest('.daile-cart__upsells');
        var nowCollapsed = upBox ? upBox.classList.toggle('is-collapsed') : false;
        upTgl.setAttribute('aria-expanded', nowCollapsed ? 'false' : 'true');
        setUpsellsCollapsed(upTgl.getAttribute('data-parent-line'), nowCollapsed);
        return;
      }
      var addBtn = e.target.closest('[data-upsell-action="add"]');
      if (addBtn) { addUpsell(addBtn.getAttribute('data-variant-id'), addBtn.getAttribute('data-parent-line'), addBtn.getAttribute('data-set-name'), addBtn); return; }
      var more = e.target.closest('[data-add-more]'); // TASK30 Фаза2
      if (more) { addOneMore(more.getAttribute('data-variant-id'), more); return; }
      var upRem = e.target.closest('[data-upsell-action="remove"]');
      if (upRem) { changeLine(upRem.getAttribute('data-line-item-key'), 0); return; } // changeLine оставлена — удаление апсейла
      if (e.target.closest('[data-daile-cart-close]')) { closeCart(); return; }

      // TASK30-C: qty-веток (increase/decrease) больше нет — qty всегда 1; только удаление строки
      var li = e.target.closest('.daile-cart__item');
      if (!li) return;
      if (e.target.closest('[data-line-item-remove]')) removeWithAttached(li.getAttribute('data-line-item-key'));
    });

    document.addEventListener('keydown', function (e) {
      if (!cart.classList.contains('is-open')) return;
      if (e.key === 'Escape' || e.key === 'Esc') { closeCart(); return; }
      if (e.key === 'Tab' && panel) {
        var f = Array.prototype.filter.call(
          panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'),
          function (el) { return el.offsetParent !== null; }
        );
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    /* ---------- перехват триггеров Prestige (CAPTURE → раньше нативных) ---------- */
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-daile-cart-open], [aria-controls="cart-drawer"], .header__cart-link a');
      if (!opener) return;
      e.preventDefault();
      e.stopPropagation();
      openCart();
      refreshCart();
    }, true);

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      handleAdd(form);
    }, true);

    /* TASK54: возврат из кастомайзера (Add to cart → редирект на PDP с
       ?daile_cart=open, ТЗ §11) — авто-открытие дровера; параметр вычищаем,
       чтобы refresh страницы не переоткрывал корзину */
    if (/[?&]daile_cart=open/.test(window.location.search)) {
      try { window.history.replaceState(null, '', window.location.pathname); } catch (e) { /* не критично */ }
      openCart();
      refreshCart();
    }

    /* DAILE custom: страница /cart — это нативная корзина Prestige, которая
       выглядит «старой» (в неё попадают из чекаута по ссылке на сумку и из писем).
       Показываем вместо неё наш дровер: уводим на предыдущую страницу магазина
       (или на главную) и сразу открываем корзину. Локаль сохраняется — берём
       корень магазина из Shopify.routes. */
    (function redirectNativeCartToDrawer() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (root.charAt(root.length - 1) !== '/') root += '/';

      var path = window.location.pathname.replace(/\/$/, '');
      var cartPath = (root + 'cart').replace(/\/\//g, '/').replace(/\/$/, '');
      if (path !== cartPath) return;

      var back = root;
      try {
        var ref = document.referrer;
        if (ref && ref.indexOf(window.location.origin) === 0 && ref.indexOf('/cart') === -1 && ref.indexOf('/checkouts') === -1) {
          back = ref.split('#')[0];
        }
      } catch (e) { /* нет referrer — уходим на главную */ }

      var glue = back.indexOf('?') === -1 ? '?' : '&';
      window.location.replace(back + glue + 'daile_cart=open');
    })();
  });
})();
